import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    set => ({
      isLoggedIn: false,
      token: null,
      user: {
        username: null,
        profilePicture: null,
      },
      signIn: ({ isLoggedIn, token, user }) => set({ isLoggedIn, token, user }),
      updateProfilePicture: profilePicture =>
        set(state => ({
          user: { ...state.user, profilePicture },
        })),
      signOut: () => set({ isLoggedIn: false, token: null, user: null }),
    }),
    {
      name: 'authStore',
    },
  ),
)

export const signOut = () => useAuthStore.getState().signOut()
